// extracted by css-extract-rspack-plugin
export default {"header":"jxH5UFhrmqguGuBt","footer":"ZZImwPAH00ayyRWa"};